import { InAppBrowserOpenerComponent } from './in-app-browser-opener.component';

export default angular
  .module('sfMobile.components.inappbrowseropener', [
    'sfMobile.services.in-app-browser',
  ])
  .component('sfInAppBrowserOpener', InAppBrowserOpenerComponent).name;
